import { render, staticRenderFns } from "./RegulatedProductStatementDeclaration.vue?vue&type=template&id=37c1db7e&"
import script from "./RegulatedProductStatementDeclaration.vue?vue&type=script&lang=js&"
export * from "./RegulatedProductStatementDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports